const { requestManager } = require('../../requestManager');

const { API_PATH } = require('../../config/config');

class OperationalLogs {
  /**
   * 処理記録を残す
   * @param {object} lclGov 自治体情報
   * @param {string} userCd 利用者CD
   * @param {string} oprCd 操作CD
   * @param {string} infoCd ログに使用する情報の種類（none/receptOnly/rsvOnly/receptOrRsv/RsvOnlyWithoutUser/receptOrRsvWithOther）
   * @param {number} receptionId 受付ID
   * @param {string} other その他の情報（文字列）
   * @return {boolean} ログ登録の成否
   */
  createOprLogs = async (lclGov, userCd, oprCd, infoCd, receptionId = null, other = '') => {
    const data = { lclGov, userCd, oprCd, infoCd, receptionId, other };
    console.log(data);
    try {
      await requestManager.post(`${API_PATH}/oprlogs/c`, data);
      return true;
    } catch {
      return false;
    }
  };
}

export default new OperationalLogs();
